import { Affix, Button, Card, Form, Space } from "antd";
import { IMPORT_CNF_BILL_LIST_ENDPOINT } from "apiServices/API_ENDPOINTS";
import { getData } from "apiServices/common";
import HandleNotification from "common/Notification";
import { isMobileView } from "components/Common/AppHelper";
import Header from "components/Common/Header";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ImportCnfBillForm from "./ImportCnfBillForm";
import { checkPermission } from "./config/checkPermission";
import { ROLES } from "./config/constants/roles";
import ImportCnfBillStatusTag from "./ImportCnfBillStatusTag";

export default function UpdateImportCnfBill(props) {
  const { width, viewMode } = props;
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { importCnfBillId } = useParams();
  const [editInfo, setEditInfo] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const loggedInUserId = parseInt(localStorage.getItem("user_id"), 10);
  const loggedInUserRole = localStorage.getItem("user_type");

  const isCreator = editInfo && loggedInUserId === editInfo?.user?.id;

  const canUpdate = useMemo(() => {
    if (!editInfo || viewMode) return false;
    return checkPermission(
      loggedInUserRole,
      editInfo.status,
      isCreator,
      "update",
      editInfo?.department_approve,
      editInfo?.director_approve,
    );
  }, [editInfo, viewMode, loggedInUserRole, isCreator]);

  const canEditInvoice = useMemo(() => {
    if (!canUpdate) return false;
    return (
      (loggedInUserRole === ROLES.DEPARTMENT_HEAD &&
        editInfo?.status === "requested") ||
      (isCreator && editInfo?.status === "created")
    );
  }, [canUpdate, loggedInUserRole, editInfo?.status, isCreator]);

  const load = useCallback(async (id) => {
    const response = await getData(`${IMPORT_CNF_BILL_LIST_ENDPOINT}/${id}`);
    if (response?.status === 200 && response?.data?.code === 200) {
      setEditInfo(response.data.data);
    } else {
      HandleNotification(
        "error",
        "bottomRight",
        "Failed to load bill",
        response?.data?.message || "",
      );
    }
  }, []);

  useEffect(() => {
    if (importCnfBillId) load(importCnfBillId);
  }, [importCnfBillId, load]);

  return (
    <>
      <Affix offsetTop={0}>
        <Card
          className="p-fixed"
          style={{ width: `${isMobileView() ? "100%" : width ? `${width}px` : "100%"}` }}
        >
          <Header
            title={`${viewMode || !canUpdate ? "View" : "Edit"} Import C&F Bill`}
            subTitle={
              editInfo?.status ? <ImportCnfBillStatusTag status={editInfo.status} /> : ""
            }
            addLink="/"
            addText=""
            actions={
              <Space>
                <Button
                  danger
                  size="small"
                  onClick={() =>
                    navigate(
                      "/import-export-expense-tracking/external-cnf-bills/import-cnf-bill",
                    )
                  }
                >
                  {viewMode ? "Back" : "Discard"}
                </Button>
                {canUpdate && (
                  <Button
                    type="primary"
                    size="small"
                    loading={submitting}
                    disabled={submitting}
                    onClick={() => form.submit()}
                  >
                    {editInfo?.status === "rejected" ? "Update & Re-submit" : "Save"}
                  </Button>
                )}
              </Space>
            }
          />
        </Card>
      </Affix>
      <ImportCnfBillForm
        form={form}
        isEdit
        editInfo={editInfo}
        viewMode={viewMode || !canUpdate}
        canEditInvoice={canEditInvoice}
        billId={importCnfBillId}
        onSubmittingChange={setSubmitting}
      />
    </>
  );
}
